'use client';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Turnkey modal-active context — relocated from the frontend into the SDK
 * as part of the auth cutover. Pure React (a boolean context); no vendor
 * or DOM coupling, so it lives in `src/auth/` core and ships to web + RN.
 *
 * The SDK's Turnkey integration sets `active` from the vendor modal stack;
 * app dialog components read `useTurnkeyModalActive()` to suppress
 * dismissal while a Turnkey modal is on screen.
 */
import { createContext, useContext } from 'react';
const TurnkeyModalActiveContext = createContext(false);
/** Provider for the Turnkey modal-active state. */
export function TurnkeyModalActiveProvider({ children, active, }) {
    return (_jsx(TurnkeyModalActiveContext.Provider, { value: active, children: children }));
}
/** Whether a Turnkey modal is currently active. Safe outside the provider (false). */
export function useTurnkeyModalActive() {
    return useContext(TurnkeyModalActiveContext);
}
//# sourceMappingURL=turnkey-modal-context.js.map